import axios from 'axios';
import Config from '../config'

class ApiService {
    constructor() {
        this.baseUrl = Config.apiUrl;
    }

    async getData(apiName) {
        try {
            const token = this.getCookie('access_jwt');

            if (!token) {
                console.log('Giriş yapmanız gerekiyor.');
                return null;
            }
            const response = await axios.get(`${this.baseUrl}/${apiName}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log(response.data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async createData(apiName, data) {
        try {
            const token = this.getCookie('access_jwt');

            if (!token) {
                console.log('Giriş yapmanız gerekiyor.');
                return null;
            }
            const response = await axios.post(`${this.baseUrl}/${apiName}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log(response.data);
            return response.data;
        } catch (error) {
            console.log("Error:", error.response.data);
            return error.response.data;
        }
    }

    async updateData(apiName, data) {
        try {
            const token = this.getCookie('access_jwt');

            if (!token) {
                console.log('Giriş yapmanız gerekiyor.');
                return null;
            }

            const response = await axios.patch(`${this.baseUrl}/${apiName}`, JSON.stringify(data), {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            console.log(response.data);
            return response.data;
        } catch (error) {
            return error.response.data;
        }
    }

    async deleteData(apiName) {
        try {
            const token = this.getCookie('access_jwt');

            if (!token) {
                console.log('Giriş yapmanız gerekiyor.');
                return null;
            }

            const response = await axios.delete(`${this.baseUrl}/${apiName}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log(response.data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async login(email, password) {
        try {
            const response = await axios.post(`${this.baseUrl}/auth/login`, {
                email: email,
                password: password,
            });
            console.log(response.data.data.access_token);

            if (response.data.success && response.data.data.access_token) {
                // Giriş başarılı, JWT'yi bir çerez olarak sakla
                this.setCookie('access_jwt', response.data.data.access_token, 7); // Örnek olarak 7 gün süreyle saklanacak

                console.log('Giriş başarılı.');
                return response.data;
            } else {
                console.log('Giriş başarısız.');
                return null;
            }
        } catch (error) {
            console.error('Giriş hatası:', error);
            throw error;
        }
    }

    async logout() {
        this.removeCookie("access_jwt");
    }
    async removeCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }


    setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + date.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }

    getCookie(name) {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return "";
    }
    getUserIdFromToken() {
        const token = this.getCookie("access_jwt");
        const decodeJwt = this.parseJwt(token);


        return decodeJwt.sub;
    }
    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

}

export default new ApiService();
